// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__33zk4","sendOtp":"AuthorizeToLogin_sendOtp__1iA1V"};